module.exports = __webpack_public_path__ + "img/CHUKOT.a0a15583.png";